import _objectSpread from "@babel/runtime/helpers/objectSpread2";
export default function convertCodeBlock(component) {
  var properties = component.properties;
  var props = properties;
  return {
    brick: "eo-code-block",
    properties: _objectSpread(_objectSpread({}, props), {}, {
      themeVariant: "elevo"
    })
  };
}
//# sourceMappingURL=convertCodeBlock.js.map